import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// Services
import { AlertService } from 'src/app/core/alert.service';
import { InvoiceService } from 'src/app/invoice/services/invoice-service.service';
import { TermsconditionpolicyService } from 'src/app/shared/services/termsconditionpolicy.service';
import { CashPaymentService } from 'src/app/shared/components/payment/cash-payment/cash-payment.service';
import { ManualPaymentService } from 'src/app/shared/services/manual-payment.service';
import { ACHPaymentService } from 'src/app/shared/services/achpayment.service';
import { CreditPaymentService } from 'src/app/reports/services/creditpayment.service';
import { ServiceWorkOrderService } from 'src/app/shared/services/service-work-order.service';
import { CustomerManagementService } from 'src/app/shared/services/customer.service';
import { PaymentService } from 'src/app/shared/services/payments.service';
// Models
import {
  Customer,
  CustomerAddress,
} from 'src/app/customer/models/customer.model';
import { User } from 'src/app/shared/models/user.model';
import { SourceComponent } from 'src/app/shared/models/invoice/payment.model';
import {
  CardInfo,
  SettingsInvoice,
} from 'src/app/invoice/models/invoice.model';
import { CashPayment } from 'src/app/shared/models/invoice/cash-payment.model';
import { ManualPayment } from 'src/app/shared/models/invoice/manual-payment.model';
import {
  ACHOnFilePayment,
  ACHPayment,
} from 'src/app/shared/models/invoice/ach-payment.model';
import { CreditPayment } from 'src/app/shared/models/invoice/invoice.model';
import { WorkOrderEnum } from 'src/app/shared/models/work-order-enum';
import { CustomerCardNumber } from 'src/app/shared/models/customer.model';
// Components
import { InvoiceSummaryComponent } from 'src/app/invoice/invoice-summary/invoice-summary.component';
import { CustomerAddressFormComponent } from 'src/app/shared/components/customers/customer-address-form/customer-address-form.component';
import { PaymentConfirmActionComponent } from 'src/app/shared/dialogs/payment-confirm-action/payment-confirm-action.component';
import { InvoiceNotesComponent } from 'src/app/invoice/invoice-notes/invoice-notes.component';
import { PaymentTermsComponent } from './payment-terms/payment-terms.component';
import { AchPayTcComponent } from './ach-pay/ach-pay-tc/ach-pay-tc.component';
import { RecurringPaymentDetailComponent } from 'src/app/formiobuilder/components/formbuilder-recurring-payments-list/recurring-payment-detail/recurring-payment-detail.component';
import { ACH } from '../../models/invoice/ach.model';
import { AddACH } from '../../models/invoice/add-ach.model';
import { AuthorizationBase } from 'src/app/core/authorize-base';

@Component({
  selector: 'app-payment-options',
  templateUrl: './payment-options.component.html',
  styleUrls: ['./payment-options.component.scss'],
})
export class PaymentOptionsComponent
  extends AuthorizationBase
  implements OnInit, OnDestroy
{
  @Input() invoiceStatus: string;
  @Input() userInfo: User;
  @Input() customerId: number;
  @Input() invoice: any;
  @Input() invoiceSettings: SettingsInvoice;
  @Input() customer: Customer;
  @Input() customerAddresses: CustomerAddress[];
  @Input() customerBusinessContact: any;
  @Input() customerSignature: any;
  @Input() locationData: any;
  @Input() workOrder: any;
  @Input() businessInfo: any;
  @Input() recurringPaymentDetails: any;
  @Input() isInvoiceSummary: boolean = false;
  @Input() isRecurringPayment: boolean = false;
  @Input() isPartialPayment: boolean = false;
  @Input() canPayPartial: boolean = false;
  @Input() displayBalance: any;
  @Input() recurringInvoiceConfig: any;

  @Input()
  get hideManualPaymentOption(): boolean {
    return this._hideManualPaymentOption;
  }
  set hideManualPaymentOption(value: boolean) {
    this._hideManualPaymentOption = value;

    let method = this.paymentMethods.find(
      (method) => method.value === 'manual'
    );
    method.enabled = !this._hideManualPaymentOption;
  }
  protected _hideManualPaymentOption = false;

  @Input()
  get showACHPaymentOption(): boolean {
    return this._showACHPaymentOption;
  }
  set showACHPaymentOption(value: boolean) {
    this._showACHPaymentOption = value;

    let method = this.paymentMethods.find((method) => method.value === 'ach');
    method.enabled = this._showACHPaymentOption;
  }
  protected _showACHPaymentOption = false;

  @Input()
  get showCashPayment(): boolean {
    return this._showCashPayment;
  }
  set showCashPayment(value: boolean) {
    this._showCashPayment = value;

    let method = this.paymentMethods.find((method) => method.value === 'cash');
    method.enabled = this._showCashPayment;
  }
  protected _showCashPayment = true;

  @Input()
  get showCreditCardOption(): boolean {
    return this._showCreditCardOption;
  }
  set showCreditCardOption(value: boolean) {
    this._showCreditCardOption = value;

    let method = this.paymentMethods.find((method) => method.value === 'card');
    method.enabled = this._showCreditCardOption;
  }
  protected _showCreditCardOption = true;

  @Output() back: EventEmitter<void> = new EventEmitter();

  isLoading: boolean = false;
  isSubmitted: boolean = false;
  isProcessing: boolean = false;
  isAgreedToTerms: boolean = false;
  isEmailReceipt: boolean = false;
  isFromAddress: boolean = false;
  isSaveCard: boolean = false;
  isNewCard: boolean = false;
  isNewACH: boolean = false;
  isSaveACH: boolean = false;

  termsAndConditions: any;
  paymentSteps: string[] = ['pay-options', 'pay-methods', 'pay-form'];
  currentStep: string = this.paymentSteps[0];

  customerAddress: any = new CustomerAddress();
  shippingAddress: any = new CustomerAddress();
  cashPayment: CashPayment = new CashPayment();
  manualPayment: ManualPayment = new ManualPayment();
  achPayment: ACHPayment = new ACHPayment();
  creditPayment: CreditPayment = new CreditPayment();
  cardInfo: CardInfo = new CardInfo();
  customerCard: CustomerCardNumber = new CustomerCardNumber();
  selectedCard: any;
  cardToken: any;
  multiUseToken: any;

  formData: any = {
    manualForm: null,
    achForm: null,
    cardForm: null,
  };

  paymentOptions: any = [
    { name: 'Pay in Full', value: 'full', icon: 'pay-in-full' },
    { name: 'Pay in Partial', value: 'partial', icon: 'pay-in-partial' },
  ];

  selectedMethod: any;
  paymentMethods: any = [
    { name: 'Pay via Card', value: 'card', icon: 'pay-card', enabled: true },
    { name: 'Pay via ACH', value: 'ach', icon: 'pay-ach', enabled: true },
    {
      name: 'Manual Payment',
      value: 'manual',
      icon: 'pay-manual',
      enabled: true,
    },
    { name: 'Cash Payment', value: 'cash', icon: 'pay-cash', enabled: true },
  ];

  dialogOption: any = {
    centered: true,
    size: 'lg',
    backdrop: 'static',
    backdropClass: 'semi',
    animation: true,
  };

  readonly unsubscribe$ = new Subject();
  selectedACHDetail: ACH;

  constructor(
    private modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private alert: AlertService,
    private invoiceService: InvoiceService,
    private termsPolicyService: TermsconditionpolicyService,
    private cashPaymentService: CashPaymentService,
    private manualPaymentService: ManualPaymentService,
    private achPaymentService: ACHPaymentService,
    private creditService: CreditPaymentService,
    private workOrderService: ServiceWorkOrderService,
    private customerService: CustomerManagementService,
    private paymentService: PaymentService
  ) {
    super();
  }

  ngOnInit() {
    if (!this.isFromAddress) {
      this.isLoading = true;

      if (!this.canPayPartial) {
        this.currentStep =
          this.paymentSteps[this.paymentSteps.indexOf(this.currentStep) + 1];
        this.isPartialPayment = false;
      }

      this.termsPolicyService
        .getTerms()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((data: any) => {
          this.termsAndConditions = data.find((item) => {
            return item.Type === 1 && item.IsDefault;
          });

          setTimeout(() => {
            this.isLoading = false;
          }, 800);
        });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onClose(data?: any) {
    this.modalRef.close(data);
  }

  isFirstStep(): boolean {
    return (
      (this.canPayPartial && this.currentStep === this.paymentSteps[0]) ||
      (!this.canPayPartial && this.currentStep === this.paymentSteps[1])
    );
  }

  getHeaderLabel(): string {
    return this.currentStep !== 'pay-form'
      ? `Payment Option for Invoice ${this.invoice.invoiceNumber}`
      : 'Process Payment';
  }

  getBackLabel(): string {
    if (this.isFirstStep()) {
      if (this.isInvoiceSummary) {
        return 'Invoice Details';
      }

      if (this.isRecurringPayment) {
        return 'Recurring Payment Details';
      }
    }

    return 'Payment Method';
  }

  getCustomerName(): string {
    if (this.customer) {
      return this.customer.CustomerTypeId === 1
        ? this.customer.FirstName + ' ' + this.customer.LastName
        : this.customer.BusinessName;
    }
  }

  getDefaultCustomerAddress(): string {
    if (this.customerAddresses) {
      const address = this.customerAddresses.find((e) => e.IsDefault);

      if (address) {
        return `${address.StreetAddress || ''} ${address.City || ''} ${
          address.State || ''
        } ${address.ZipCode || ''}`;
      }

      return '-';
    }
  }

  setComponentData(dialog: NgbModalRef): void {
    // Much better to store data on a service
    dialog.componentInstance.isLoading = true;
    dialog.componentInstance.selectedMethod = this.paymentMethods.find(
      (e) => e.value === this.selectedMethod.value
    );
    dialog.componentInstance.currentStep = 'pay-form';

    dialog.componentInstance.isInvoiceSummary = this.isInvoiceSummary;
    dialog.componentInstance.canPayPartial = this.canPayPartial;
    dialog.componentInstance.isPartialPayment = this.isPartialPayment;
    dialog.componentInstance.userInfo = this.userInfo;
    dialog.componentInstance.invoice = this.invoice;
    dialog.componentInstance.invoiceSettings = this.invoiceSettings;
    dialog.componentInstance.customer = this.customer;
    dialog.componentInstance.customerBusinessContact =
      this.customerBusinessContact;
    dialog.componentInstance.customerAddresses = this.customerAddresses;
    dialog.componentInstance.customerAddress = this.customerAddress;
    dialog.componentInstance.shippingAddress = this.shippingAddress;
    dialog.componentInstance.customerSignature = this.customerSignature;
    dialog.componentInstance.businessInfo = this.businessInfo;
    dialog.componentInstance.locationData = this.locationData;
    dialog.componentInstance.workOrder = this.workOrder;
    dialog.componentInstance.displayBalance = this.displayBalance;
    dialog.componentInstance.hideManualPaymentOption =
      this.hideManualPaymentOption;
    dialog.componentInstance.showACHPaymentOption = this.showACHPaymentOption;
    dialog.componentInstance.showCashPayment = this.showCashPayment;
    dialog.componentInstance.termsAndConditions = this.termsAndConditions;
    dialog.componentInstance.creditPayment = this.creditPayment;
    dialog.componentInstance.cardInfo = this.cardInfo;
    dialog.componentInstance.selectedCard = this.selectedCard;
    dialog.componentInstance.achPayment = this.achPayment;
    dialog.componentInstance.isAgreedToTerms = this.isAgreedToTerms;
    dialog.componentInstance.isEmailReceipt = this.isEmailReceipt;
    dialog.componentInstance.formData = this.formData;
  }

  onBack(): void {
    if (this.isFirstStep()) {
      if (this.isInvoiceSummary) {
        return this.onReturnInvoiceDetails();
      }

      if (this.isRecurringPayment) {
        return this.onReturnRecurringPaymentDetails();
      }

      return this.onClose();
    }

    this.currentStep =
      this.paymentSteps[this.paymentSteps.indexOf(this.currentStep) - 1];
  }

  onReturnInvoiceDetails(): void {
    let invoiceDiag = this.modalService.open(InvoiceSummaryComponent, {
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
    });

    invoiceDiag.componentInstance.invoiceNumber = this.invoice.invoiceNumber;
    this.onClose();
  }

  onReturnRecurringPaymentDetails(): void {
    let invoiceDiag = this.modalService.open(RecurringPaymentDetailComponent, {
      size: 'md',
    });

    invoiceDiag.componentInstance.recurringId =
      this.recurringPaymentDetails.recurringId;
    invoiceDiag.componentInstance.invoiceNumber =
      this.recurringPaymentDetails.invoiceNumber;
    invoiceDiag.componentInstance.status = this.recurringPaymentDetails.status;
    this.onClose();
  }

  onOptionSelect(option: string): void {
    this.currentStep =
      this.paymentSteps[this.paymentSteps.indexOf(this.currentStep) + 1];
    this.isPartialPayment = option === 'partial';
  }

  onMethodSelect(method: any): void {
    this.currentStep =
      this.paymentSteps[this.paymentSteps.indexOf(this.currentStep) + 1];
    this.selectedMethod = method;

    this.isAgreedToTerms = false;
    this.isEmailReceipt = false;
    this.isProcessing = false;
    this.isSubmitted = false;
    this.isSaveCard = false;
    this.isNewCard = false;
    this.isNewACH = false;
  }

  onOpenTermsAndCondition(): void {
    if (this.selectedMethod.value === 'ach') {
      let achTerms = this.modalService.open(AchPayTcComponent, {
        ...this.dialogOption,
      });

      achTerms.componentInstance.merchantName = this.businessInfo.BusinessName;
      achTerms.componentInstance.contactNumber =
        this.businessInfo.ContactNumber;
      achTerms.componentInstance.isAgreed = this.isAgreedToTerms;

      achTerms.result.then((res) => {
        if (res) {
          this.isAgreedToTerms = true;
        }
      });
    } else {
      let paymentTerms = this.modalService.open(PaymentTermsComponent, {
        ...this.dialogOption,
      });

      paymentTerms.componentInstance.content = this.termsAndConditions.Content;
      paymentTerms.componentInstance.isAgreed = this.isAgreedToTerms;

      paymentTerms.result.then((res) => {
        if (res) {
          this.isAgreedToTerms = true;
        }
      });
    }
  }

  onValueChange(key: string, form: any): void {
    this.formData[key] = form;
  }

  onAddressAdd(isShipping: boolean = false): void {
    let addressDiag = this.modalService.open(CustomerAddressFormComponent);

    addressDiag.componentInstance.customerId = this.invoice.customerId;

    this.onClose();

    addressDiag.result.then((res) => {
      let paymentDiag = this.modalService.open(PaymentOptionsComponent);

      this.setComponentData(paymentDiag);
      paymentDiag.componentInstance.isFromAddress = true;

      if (res) {
        paymentDiag.componentInstance.customerAddresses.push(res);
        paymentDiag.componentInstance[
          !isShipping ? 'customerAddress' : 'shippingAddress'
        ] = res;
      }

      setTimeout(() => {
        paymentDiag.componentInstance.isLoading = false;
        paymentDiag.componentInstance.isFromAddress = false;
      }, 800);
    });
  }

  onCardAdd(isAdd: boolean): void {
    this.isNewCard = isAdd;
  }

  onACHAdd(isAdd: boolean): void {
    this.isNewACH = isAdd;
  }

  onACHSelect(ach: ACH): void {
    this.selectedACHDetail = ach;
  }

  onCardSelect(card: any): void {
    this.selectedCard = card;
  }

  onTokenReceive(data: any): void {
    if (data.token) {
      this.cardToken = data.token;

      const address = this.customerAddresses.find((e) => {
        if (data.addressId) {
          return e.Id === data.addressId;
        }
        return e.IsDefault;
      });

      if (address) {
        this.customerAddress.Id = address.Id;
        this.customerAddress.City = address.City;
        this.customerAddress.State = address.State;
        this.customerAddress.PostalCode = address.ZipCode;
        this.customerAddress.StreetAddress1 = address.StreetAddress;

        this.creditPayment.billingAddress = this.customerAddress;
      }

      if (
        data.token.details.cardType === 'amex' &&
        !this.customerAddress.PostalCode
      ) {
        this.alert.alertError({
          title: 'Invoice Payment Failed',
          text: 'An American Express card requires a zip code for verification and the selected address has no zip code specified. Please edit it via Customers > Edit Customer > Zip Code field.',
        });
        return;
      }

      if (!data.addressId) {
        this.alert.alertError({
          title: 'Invoice Payment Failed',
          text: 'Please select an address.',
        });
        return;
      }

      if (!this.isAgreedToTerms) {
        this.alert.alertError({
          title: 'Invoice Payment Failed',
          text: 'Please Agree to the Terms and Conditions.',
        });
        return;
      }

      // Added For Transit Notes Requirement
      if (this.businessInfo?.Processor.toLowerCase() === 'tsys') {
        if (
          data.token.details.cardType === 'amex' &&
          !this.invoice.notes &&
          [2, 3].includes(this.customer.LevelProcessing)
        ) {
          let modal = this.modalService.open(InvoiceNotesComponent);
          this.onClose();

          modal.result.then((res: any) => {
            let paymentDiag = this.modalService.open(PaymentOptionsComponent);
            this.setComponentData(paymentDiag);

            if (!res) {
              this.alert.alertError({
                title: 'Invoice Payment Failed',
                text: 'An American Express card requires an invoice notes for Level 2 or 3 Customers.',
              });

              return;
            }

            paymentDiag.componentInstance.isProcessing = true;
            paymentDiag.componentInstance.creditPayment.Notes = res;
            this.onNewCardPayment(data);
          });
          return;
        }

        this.onNewCardPayment(data);
        return;
      }

      this.onNewCardPayment(data);
    }
  }

  async onProcessPayment(): Promise<void> {
    if (!this.isAgreedToTerms) {
      this.alert.alertError({
        title: 'Invoice Payment Failed',
        text: 'Please agree to the Terms and Conditions',
      });
      return;
    }

    this.isSubmitted = true;

    switch (this.selectedMethod.value) {
      case 'cash':
        await this.onCashPayment();
        break;
      case 'manual':
        await this.onManualPayment();
        break;
      case 'ach':
        if (this.isNewACH) {
          await this.onACHPayment();
        } else {
          await this.onACHOnFilePayment();
        }
        break;
      case 'card':
        await this.onCardPayment();
        break;
    }
  }

  onCashPayment(): void {
    this.isProcessing = true;

    this.cashPayment.InvoiceId = this.invoice.id;
    this.cashPayment.InvoiceNumber = this.invoice.invoiceNumber;
    this.cashPayment.CustomerId = this.invoice.customerId;
    this.cashPayment.EmailReceiptToClient = this.isEmailReceipt;
    this.cashPayment.PaymentType = this.isPartialPayment ? 2 : 1;
    this.cashPayment.LocationId = this.locationData.Id;
    this.cashPayment.Amount = parseFloat(
      this.invoice.status === 'Partial' || this.isPartialPayment
        ? this.displayBalance
        : this.invoice.balance
    );

    if (this.businessInfo) {
      this.cashPayment.BusinessName = this.businessInfo.BusinessName;
      this.cashPayment.BusinessLogo = this.businessInfo.Logo;
      this.cashPayment.BusinessAddress = `${
        this.businessInfo.Address1 ? this.businessInfo.Address1 + ',' : ''
      } ${this.businessInfo.City ? this.businessInfo.City + ',' : ''} ${
        this.businessInfo.Province ? this.businessInfo.Province + ',' : ''
      } ${this.businessInfo.StateId || ''} ${
        this.businessInfo.PostalCode || ''
      } ${this.businessInfo.CountryCode || ''}`;
    }

    if (this.customer) {
      this.cashPayment.CustomerName = this.getCustomerName();
      this.cashPayment.CustomerEmail = this.customer.EmailAddress;

      if (this.customerBusinessContact) {
        this.cashPayment.CustomerEmail =
          this.customerBusinessContact.EmailAddress ||
          this.customer.EmailAddress;
      }

      if (this.getDefaultCustomerAddress()) {
        this.cashPayment.CustomerAddress = this.getDefaultCustomerAddress();
      }
    }

    this.cashPaymentService
      .addManualPayment(this.cashPayment)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isProcessing = false;
        this.onConfirmPayment();
      });
  }

  onManualPayment(): void {
    if (this.formData.manualForm && this.formData.manualForm.valid) {
      this.isProcessing = true;

      this.manualPayment.InvoiceId = this.invoice.id;
      this.manualPayment.InvoiceNumber = this.invoice.invoiceNumber;
      this.manualPayment.CustomerId = this.invoice.customerId;
      this.manualPayment.EmailReceiptToClient = this.isEmailReceipt;
      this.manualPayment.PaymentType = this.isPartialPayment ? 2 : 1;
      this.manualPayment.Amount = parseFloat(
        this.invoice.status === 'Partial' || this.isPartialPayment
          ? this.displayBalance
          : this.invoice.balance
      );

      if (this.businessInfo) {
        this.manualPayment.BusinessName = this.businessInfo.BusinessName;
        this.manualPayment.BusinessLogo = this.businessInfo.Logo;
        this.manualPayment.BusinessAddress = `${
          this.businessInfo.Address1 ? this.businessInfo.Address1 + ',' : ''
        } ${this.businessInfo.City ? this.businessInfo.City + ',' : ''} ${
          this.businessInfo.Province ? this.businessInfo.Province + ',' : ''
        } ${this.businessInfo.StateId || ''} ${
          this.businessInfo.PostalCode || ''
        } ${this.businessInfo.CountryCode || ''}`;
      }

      if (this.customer) {
        this.manualPayment.CustomerName = this.getCustomerName();
        this.manualPayment.CustomerEmail = this.customer.EmailAddress;

        if (this.customerBusinessContact) {
          this.manualPayment.CustomerEmail =
            this.customerBusinessContact.EmailAddress ||
            this.customer.EmailAddress;
        }

        if (this.getDefaultCustomerAddress()) {
          this.manualPayment.CustomerAddress = this.getDefaultCustomerAddress();
        }
      }

      for (const [key, value] of Object.entries(
        this.formData.manualForm.value
      )) {
        if (value) {
          if (key === 'PaymentDate') {
            this.manualPayment[key] = new Date(value as string);
            continue;
          }

          this.manualPayment[key] = value;
        }
      }

      this.manualPaymentService
        .addManualPayment(this.manualPayment)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          this.isSubmitted = false;
          this.isProcessing = false;
          this.onConfirmPayment();
        });
    }
  }

  onACHOnFilePayment(): void {
    if (this.selectedACHDetail) {
      this.isProcessing = true;
      const payload: ACHOnFilePayment = {
        customerId: this.customer.Id,
        locationId: this.locationData.Id,
        amount: parseFloat(
          this.invoice.status === 'Partial' || this.isPartialPayment
            ? this.displayBalance
            : this.invoice.balance
        ),
        paymentIdentifier: this.selectedACHDetail.paymentIdentifier,
        currency: 'USD',
        terminalId: 'MAIN',
        transactionSource: !!this.workOrder
          ? SourceComponent.WorkOrder
          : this.isRecurringPayment
          ? SourceComponent.RecurringPayment
          : SourceComponent.ManualInvoice,
        invoiceNumber: this.invoice.invoiceNumber,
        isPartialPayment: this.isPartialPayment,
        sourceComponent: !!this.workOrder
          ? SourceComponent.WorkOrder
          : SourceComponent.ManualInvoice,
        userId: Number(this.userInfo.UserId),
      };

      this.achPaymentService
        .achOnFileCharge(payload)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res: any) => {
            if (res) {
              this.isSubmitted = false;
              this.isProcessing = false;
              this.onConfirmPayment();
            }
          },
          (err: any) => {
            this.alert.alertError({
              title: 'Invoice Payment Failed',
              text: `Payment failed for invoice number: ${this.invoice.invoiceNumber}`,
            });

            this.isProcessing = false;
            this.isSubmitted = false;
          }
        );
    }
  }

  onSaveNewACHDetail(): Promise<void> {
    const payload: AddACH = {
      customerId: this.customer.Id,
      locationId: this.locationData.Id,
      firstName: this.customer.FirstName,
      lastName: this.customer.LastName,
      accountNumber: this.formData.achForm.value.AccountNumber,
      routingNumber: this.formData.achForm.value.RoutingNumber,
      checkType: this.formData.achForm.value.CheckType,
      accountType: this.formData.achForm.value.AccountType,
      streetAddress1: this.achPayment.StreetAddress1,
      city: this.achPayment.City,
      state: this.achPayment.State,
      postalCode: this.achPayment.PostalCode,
      country: this.achPayment.Country,
    };

    return new Promise((resolve, reject) => {
      this.customerService
        .addCustomerACHDetails(payload)
        .subscribe((res: any) => {
          resolve();
        });
    });
  }

  async onACHPayment(): Promise<void> {
    if (this.formData.achForm && this.formData.achForm.valid) {
      this.isProcessing = true;

      this.achPayment.InvoiceNumber = this.invoice.invoiceNumber;
      this.achPayment.TerminalId = 'MAIN';
      this.achPayment.IsPartialPayment = this.isPartialPayment;
      this.achPayment.Currency = 'USD';
      this.achPayment.LocationId = this.locationData.Id;
      this.achPayment.CustomerId = this.invoice.customerId.toString();

      this.achPayment.SourceComponent = !!this.workOrder
        ? SourceComponent.WorkOrder
        : SourceComponent.ManualInvoice;
      this.achPayment.TransactionSource = !!this.workOrder
        ? SourceComponent.WorkOrder
        : this.isRecurringPayment
        ? SourceComponent.RecurringPayment
        : SourceComponent.ManualInvoice;

      this.achPayment.Amount = parseFloat(
        this.invoice.status === 'Partial' || this.isPartialPayment
          ? this.displayBalance
          : this.invoice.balance
      );

      for (const [key, value] of Object.entries(this.formData.achForm.value)) {
        if (value) {
          if (key === 'Address') {
            this.customerAddress.Id = value;
            continue;
          }

          this.achPayment[key] = value;
        }
      }

      const address = this.customerAddresses.find((e) => {
        if (this.customerAddress.Id) {
          return e.Id === this.customerAddress.Id;
        }
        return e.IsDefault;
      });

      if (address) {
        this.achPayment.StreetAddress1 = address.StreetAddress;
        this.achPayment.City = address.City;
        this.achPayment.State = address.State;
        this.achPayment.PostalCode = address.ZipCode;
        this.achPayment.Country = address.CountryCode;
      }

      if (this.isSaveACH) {
        await this.onSaveNewACHDetail();
      }

      this.achPaymentService
        .achCharge(this.achPayment)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res: any) => {
            if (res) {
              this.isSubmitted = false;
              this.isProcessing = false;
              this.onConfirmPayment();
            }
          },
          () => {
            this.alert.alertError({
              title: 'Invoice Payment Failed',
              text: `Payment failed for invoice number: ${this.invoice.invoiceNumber}`,
            });

            this.isProcessing = false;
            this.isSubmitted = false;
          }
        );
    }
  }

  onCardPayment(): void {
    if (this.formData.cardForm && this.formData.cardForm.valid) {
      for (const [key, value] of Object.entries(this.formData.cardForm.value)) {
        if (value) {
          if (key === 'CVV') {
            this.cardInfo.cvn = value as string;
          }

          if (key === 'BillingAddress') {
            this.customerAddress.Id = value;

            const address = this.customerAddresses.find((e) => {
              if (this.customerAddress.Id) {
                return e.Id === this.customerAddress.Id;
              }
              return e.IsDefault;
            });

            if (address) {
              this.customerAddress.Id = address.Id;
              this.customerAddress.City = address.City;
              this.customerAddress.State = address.State;
              this.customerAddress.PostalCode = address.ZipCode;
              this.customerAddress.StreetAddress1 = address.StreetAddress;

              this.creditPayment.billingAddress = this.customerAddress;
            }
            continue;
          }

          if (key === 'ShippingAddress') {
            this.shippingAddress.Id = value;

            const address = this.customerAddresses.find((e) => {
              if (this.shippingAddress.Id) {
                return e.Id === this.shippingAddress.Id;
              }
              return e.AddressType === 3 || e.IsDefault;
            });

            if (address) {
              this.shippingAddress.Id = address.Id;
              this.shippingAddress.City = address.City;
              this.shippingAddress.State = address.State;
              this.shippingAddress.PostalCode = address.ZipCode;
              this.shippingAddress.StreetAddress1 = address.StreetAddress;

              this.creditPayment.shippingAddress = this.shippingAddress;
            }
            continue;
          }
        }
      }

      this.cardInfo.token = this.selectedCard.Token;
      this.cardInfo.number = this.selectedCard.CardLast4Digits;
      this.cardInfo.expMonth = this.selectedCard.ExpMonth;
      this.cardInfo.expYear = this.selectedCard.ExpYear;
      this.cardInfo.cardType = this.selectedCard.CardBrand;
      this.cardInfo.cardBrandTransactionId =
        this.selectedCard.CardBrandTransactionId;
      this.cardInfo.isCOF = true;

      this.creditPayment.currency = 'USD';
      this.creditPayment.cardInfo = this.cardInfo;
      this.creditPayment.invoiceNumber = this.invoice.invoiceNumber;
      this.creditPayment.terminalId = 'MAIN';
      this.creditPayment.isPartialPayment = this.isPartialPayment;

      this.creditPayment.SourceComponent = !!this.workOrder
        ? SourceComponent.WorkOrder
        : SourceComponent.ManualInvoice;
      this.creditPayment.TransactionSource = !!this.workOrder
        ? SourceComponent.WorkOrder
        : this.isRecurringPayment
        ? SourceComponent.RecurringPayment
        : SourceComponent.ManualInvoice;

      this.creditPayment.amount = parseFloat(
        this.invoice.status === 'Partial' || this.isPartialPayment
          ? this.displayBalance
          : this.invoice.balance
      );
      this.creditPayment.gratuity = 0;

      this.creditPayment.customerId = this.invoice.customerId;
      this.creditPayment.Level =
        this.customer.LevelProcessing?.toLocaleString() || '';
      this.creditPayment.Notes = this.invoice.notes || '';

      if (!this.selectedCard.Token) {
        this.alert.alertError({
          text: 'Please input card details and verify the card first.',
        });
        return;
      }

      if (
        this.selectedCard.CardBrand === 'amex' &&
        !this.invoice.notes &&
        [2, 3].includes(this.customer.LevelProcessing)
      ) {
        let modal = this.modalService.open(InvoiceNotesComponent);
        this.onClose();

        modal.result.then((res: any) => {
          let paymentDiag = this.modalService.open(PaymentOptionsComponent);
          this.setComponentData(paymentDiag);

          if (!res) {
            this.alert.alertError({
              title: 'Invoice Payment Failed',
              text: 'An American Express card requires an invoice notes for Level 2 or 3 Customers.',
            });

            return;
          }

          paymentDiag.componentInstance.isProcessing = true;
          paymentDiag.componentInstance.creditPayment.Notes = res;
          this.onProcessCardPayment();
        });

        return;
      }

      this.onProcessCardPayment();
    }
  }

  onProcessCardPayment(): void {
    this.isProcessing = true;

    this.creditService
      .creditChargeOnly(
        this.creditPayment,
        this.userInfo.UserId,
        this.invoice.locationId,
        ''
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res: any) => {
          if (res) {
            // Audit Trail
            this.creditService
              .addAuditTrail(res)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe(
                (auditres: any) => {
                  if (auditres) {
                    // Audit Trail Successful
                  }
                },
                (error) => {
                  this.alert.alertError({
                    title: 'Payment successful but audit trail failed',
                    text: error.error,
                  });
                },
                () => {
                  // Send Receipt
                  const payload = {
                    emailAddress: this.customer.EmailAddress,
                    mobileNumber: null,
                    paymentMethod: 'Credit',
                    receiptNumber: res.receiptNumber,
                  };

                  this.paymentService
                    .sendReceipt(payload)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe(
                      (receiptres: any) => {
                        if (receiptres) {
                          // Send receipt successful
                        }
                      },
                      (error) => {
                        this.alert
                          .alertWarning({
                            title: `Payment Successful<br>Sending Receipt Failed`,
                            text: `The payment was done successfully.<br> Unfortunately, there was an error encountered
                          while sending the receipt.<br>
                          <br><br>Please check Transaction Reports to retry sending the receipt to the customer.`,
                          })
                          .then((result) => {
                            if (result.isDismissed || result.isConfirmed) {
                              this.onProcessTip(res);
                            }
                          });
                      },
                      () => {
                        this.onProcessTip(res);
                      }
                    );
                }
              );
          }
        },
        (error) => {
          if (error.error.toLowerCase().indexOf('authorization') >= 0) {
            this.alert.alertSuccess({
              title: 'Success',
              text: 'Authorization successful.',
            });
            return;
          }
          this.alert.alertError({
            title: 'Invoice Payment failed',
            text: error.error,
          });
          this.isProcessing = false;
        }
      );
  }

  onProcessTip(result: any): void {
    this.creditService
      .processTip(result)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (tipres: any) => {
          if (tipres) {
            // Tip processing successful
          }
        },
        (error) => {
          this.alert.alertError({
            title: 'Payment successful but tip processing failed',
            text: error.error,
          });
        },
        () => {
          if (this.selectedCard) {
            this.onCardAssignToRecurringInvoice(
              this.creditPayment.invoiceNumber,
              this.selectedCard.Id
            );
          }

          this.onConfirmPayment();
          this.isProcessing = false;
        }
      );
  }

  onNewCardPayment(data: any): void {
    this.isProcessing = true;

    this.cardInfo.token = this.cardToken.paymentReference;
    this.cardInfo.number = this.cardToken.details.cardLast4;
    this.cardInfo.cardBIN = this.cardToken.details.cardBin;
    this.cardInfo.expMonth = this.cardToken.details.expiryMonth;
    this.cardInfo.expYear = this.cardToken.details.expiryYear;
    this.cardInfo.cvn = this.cardToken.details.cvv;

    this.creditPayment.currency = 'USD';
    this.creditPayment.cardInfo = this.cardInfo;
    this.creditPayment.invoiceNumber = this.invoice.invoiceNumber;
    this.creditPayment.terminalId = 'MAIN';
    this.creditPayment.customerId = this.invoice.customerId;
    this.creditPayment.gratuity = 0;

    this.creditPayment.SourceComponent = !!this.workOrder
      ? SourceComponent.WorkOrder
      : SourceComponent.ManualInvoice;
    this.creditPayment.TransactionSource = !!this.workOrder
      ? SourceComponent.WorkOrder
      : this.isRecurringPayment
      ? SourceComponent.RecurringPayment
      : SourceComponent.ManualInvoice;

    this.creditPayment.amount = parseFloat(
      this.invoice.status === 'Partial' || this.isPartialPayment
        ? this.displayBalance
        : this.invoice.balance
    );

    if (this.businessInfo?.Processor.toLowerCase() === 'tsys') {
      const address = this.customerAddresses.find((e) => {
        if (data.addressShippingId) {
          return e.Id === this.shippingAddress.Id;
        }
        return e.AddressType === 3 || e.IsDefault;
      });

      if (address) {
        this.shippingAddress.Id = address.Id;
        this.shippingAddress.City = address.City;
        this.shippingAddress.State = address.State;
        this.shippingAddress.PostalCode = address.ZipCode;
        this.shippingAddress.StreetAddress1 = address.StreetAddress;

        this.creditPayment.shippingAddress = this.shippingAddress;
      }

      this.creditPayment.Level =
        this.customer.LevelProcessing?.toLocaleString() || '';
      this.creditPayment.Notes = this.creditPayment.Notes || this.invoice.notes;
    }

    this.creditPayment.billingAddress = this.customerAddress;
    this.creditPayment.LocationId = this.locationData.Id;
    this.onProcessNewCardPayment();
  }

  onProcessNewCardPayment(): void {
    this.isProcessing = true;

    this.creditPayment.isPartialPayment = this.isPartialPayment;
    this.creditPayment.cardInfo = this.cardInfo;
    this.creditPayment.requestMultiUseToken = this.isSaveCard;

    this.creditService
      .creditChargeOnly(
        this.creditPayment,
        this.userInfo.UserId,
        this.invoice.locationId.toLocaleString() || this.locationData.Id,
        'Main'
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res: any) => {
          if (res) {
            if (this.isSaveCard) {
              this.cardInfo.cardBrandTransactionId =
                res.transaction.cardBrandTransactionId;
              this.cardInfo.token = res.transaction.token;
              this.onSaveCardToFile();
            }

            if (this.customerSignature) {
              this.invoiceService
                .uploadCustomersig({
                  invoiceNumber: this.invoice.invoiceNumber,
                  signatureUrl: this.customerSignature,
                  createdBy: this.userInfo.UserId || '1',
                })
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe();
            }

            // Audit Trail
            this.creditService
              .addAuditTrail(res)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe(
                (auditres: any) => {
                  if (auditres) {
                    // Audit Trail Successful
                  }
                },
                (error) => {
                  this.alert.alertError({
                    title: 'Payment successful but audit trail failed',
                    text: error.error,
                  });
                },
                () => {
                  // Send Receipt
                  const payload = {
                    emailAddress: this.customer.EmailAddress,
                    mobileNumber: null,
                    paymentMethod: 'Credit',
                    receiptNumber: res.receiptNumber,
                  };

                  this.paymentService
                    .sendReceipt(payload)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe(
                      (receiptres: any) => {
                        if (receiptres) {
                          // Send receipt successful
                        }
                      },
                      (error) => {
                        this.alert
                          .alertWarning({
                            title: `Payment Successful<br>Sending Receipt Failed`,
                            text: `The payment was done successfully.<br> Unfortunately, there was an error encountered
                          while sending the receipt.<br>
                          <br><br>Please check Transaction Reports to retry sending the receipt to the customer.`,
                          })
                          .then((result) => {
                            if (result.isDismissed || result.isConfirmed) {
                              this.onProcessTip(res);
                            }
                          });
                      },
                      () => {
                        this.onProcessTip(res);
                      }
                    );
                }
              );
          }
        },
        (error) => {
          if (error.error.toLowerCase().indexOf('authorization') >= 0) {
            this.alert.alertSuccess({
              title: 'Success',
              text: 'Authorization successful.',
            });
            if (this.isSaveCard) {
              this.onSaveCardToFile();
              this.isProcessing = false;
            }
            return;
          }
          this.alert.alertError({
            title: 'Invoice Payment failed',
            text: error.error,
          });
          this.isProcessing = false;
        }
      );
  }

  onSaveCardToFile(): void {
    this.customerCard.Token = this.cardInfo.token;
    this.customerCard.CardLast4Digits = this.cardToken.details.cardLast4;
    this.customerCard.CardBrand = this.cardToken.details.cardType;
    this.customerCard.ExpMonth = this.cardToken.details.expiryMonth;
    this.customerCard.ExpYear = this.cardToken.details.expiryYear;
    this.customerCard.CVN = this.cardToken.details.cvv;

    this.customerCard.IsDeleted = false;
    this.customerCard.CreatedBy = 2;
    this.customerCard.CreatedDate = new Date();
    this.customerCard.UpdatedBy = null;
    this.customerCard.UpdatedDate = null;
    this.customerCard.Id = 0;
    this.customerCard.CustomerId = this.invoice.customerId;

    this.customerService
      .addCustomerCardNumber(this.customerCard)
      .subscribe((res: any) => {
        this.onCardAssignToRecurringInvoice(this.invoice.invoiceNumber, res);
        if (res) {
          this.alert.alertSuccess({
            title: 'Success',
            text: 'Successfully added card to file.',
          });
          this.isProcessing = false;
        }
      });
  }

  onConfirmPayment(): void {
    if (!!this.workOrder) {
      this.workOrderService.statusUpdate(
        this.workOrder.WorkOrderId,
        WorkOrderEnum.Completed,
        1
      );
    }

    if (this.invoiceSettings?.requireCustomerSignOrPasswordOnPayment) {
      let signDiag = this.modalService.open(PaymentConfirmActionComponent, {
        backdrop: 'static',
      });

      signDiag.componentInstance.hideUserPassword = true;
      this.onClose();

      signDiag.result.then((res) => {
        if (res && res.signUrl) {
          this.invoiceService
            .uploadCustomersig({
              invoiceNumber: this.invoice.invoiceNumber,
              signatureUrl: res.signUrl,
              createdBy: this.userInfo.UserId,
            })
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe();
        }

        this.alert.alertSuccess({
          title: 'Invoice Payment Successful',
          text: `You have successfully paid the invoice Transaction # ${this.invoice.invoiceNumber}`,
        });

        this.invoiceService.reloadInvoiceList();
        this.onClose();
      });

      return;
    }

    this.alert.alertSuccess({
      title: 'Invoice Payment Successful',
      text: `You have successfully paid the invoice Transaction # ${this.invoice.invoiceNumber}`,
    });

    this.invoiceService.reloadInvoiceList();
    this.onClose();
  }

  onCardAssignToRecurringInvoice(invoiceNumber: string, cardId: number) {
    if (!this.recurringInvoiceConfig) {
      this.onClose(true);
      return;
    }

    if (this.recurringInvoiceConfig.isAutoCharge) {
      this.invoiceService
        .setRecurringInvoiceCardNumberByInvoiceNumber(invoiceNumber, cardId)
        .subscribe((res) => {
          if (res) {
            this.alert
              .alertSuccess({
                title: 'Success',
                text: 'This card is now used for future payments for this recurring invoice.',
              })
              .then(() => {
                this.onClose(true);
              });
          }
        });
    } else {
      this.onClose(true);

      this.alert.alert({
        title: 'Confirmation',
        text: `Do you want to use this card for auto payment?`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes, use this card!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.invoiceService
            .setRecurringInvoiceCardNumberByInvoiceNumber(invoiceNumber, cardId)
            .subscribe(
              (result) => {
                if (result) {
                  this.alert.alertSuccess({
                    title: 'Success',
                    text: 'This card is now used for future payments for this recurring invoice.',
                  });
                  this.onClose(true);
                }
              },
              (error: any) => {
                this.alert.alertError({
                  title: 'Error',
                  text: error.error.text,
                });
              }
            );
        },
      });
    }
  }
}
